import { useContext } from "react";
import { ItemsGroupContext } from "../../contexts/itemsGroupContext";

const useItemsGroupContext = () => {
  const value = useContext(ItemsGroupContext);
  return value;
};

export default useItemsGroupContext;
